import React, { createContext, useContext, useRef, useState, useEffect } from "react";

const SpeechContext = createContext(null);
export const useSpeech = () => useContext(SpeechContext);

export function SpeechProvider({ children }) {
  const recRef = useRef(null);
  const [supported, setSupported] = useState(false);
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [interim, setInterim] = useState("");

  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    setSupported(true);
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = true;
    rec.lang = "en-AU";
    rec.onresult = (e) => {
      let finalText = "";
      let interimText = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const text = e.results[i][0].transcript.trim();
        if (e.results[i].isFinal) finalText += text + " ";
        else interimText += text + " ";
      }
      if (finalText) setTranscript((t) => (t ? t + " " : "") + finalText.trim());
      setInterim(interimText.trim());
    };
    rec.onerror = () => setListening(false);
    rec.onend = () => setListening(false);
    recRef.current = rec;
    return () => {
      try { rec.stop(); } catch {}
      recRef.current = null;
    };
  }, []);

  const start = () => {
    if (!supported || !recRef.current || listening) return;
    setTranscript("");
    setInterim("");
    try {
      recRef.current.start();
      setListening(true);
    } catch {}
  };

  const stop = () => {
    if (!recRef.current) return;
    try { recRef.current.stop(); } catch {}
    setListening(false);
  };

  const speak = (text) => {
    if (!window.speechSynthesis || !text) return;
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "en-AU";
    window.speechSynthesis.speak(u);
  };

  return (
    <SpeechContext.Provider value={{ supported, listening, start, stop, transcript, interim, setTranscript, speak }}>
      {children}
    </SpeechContext.Provider>
  );
}
